import cn from 'classnames';
import { UiTextField } from '@@/ui/components/ui-text-field';
import {
  CreateWarehouseStep,
  ICreateWarehouseStepProps,
} from '@@/warehouses/components/create-warehouse-step';

import styles from './styles.module.css';
import { useEffect } from 'react';
import { notification } from 'antd';

export function WarehouseName(props: IWarehouseNameProps) {
  const {
    className,
    name,
    canProceed,
    onChange,
    onNext,
    onCheckWarehouseName,
    validName,
    ...rest
  } = props;
  const rootClass = cn(styles.root, className);

  useEffect(() => {
    if (String(name).length >= 60)
      return notification.warning({
        message: 'Название склада можеть иметь не более 60 символов',
      });
  }, [name]);
  useEffect(() => {
    if (String(name) !== '') onCheckWarehouseName();
  }, [name]);
  return (
    <CreateWarehouseStep
      className={rootClass}
      prev={{ disabled: true }}
      next={{ disabled: !canProceed || !validName }}
      onNext={() => onNext(name)}
      {...rest}
    >
      <UiTextField
        className="name"
        label="Название склада"
        value={name}
        maxLength={60}
        required
        onChange={({ value }) => onChange(value as string)}
      />
    </CreateWarehouseStep>
  );
}

export interface IWarehouseNameProps
  extends Omit<ICreateWarehouseStepProps, 'onNext' | 'onChange'> {
  name: string;
  canProceed?: boolean;
  onChange: (name: string) => void;
  onNext: (name: string) => void;
  onCheckWarehouseName: () => Promise<void>;
  validName?: boolean;
}
